import React from 'react';
import { useUserPreferencesApi } from 'api/userPreferences';

export default function useLabelFormatPreference(carrierCode, availableFormats, isOpen) {
  // get/put API helpers
  const { getLabelFormat, setLabelFormat } = useUserPreferencesApi();
  // currently selected format
  const [selectedFormat, setSelectedFormat] = React.useState(null);
  // loading flag during fetch
  const [isPrefLoading, setIsPrefLoading] = React.useState(false);

  React.useEffect(() => {
    let mounted = true;
    if (!carrierCode || !isOpen) return;
    setIsPrefLoading(true);
    (async () => {
      try {
        // read preferred format from backend
        const preferred = await getLabelFormat(carrierCode);
        if (mounted) {
          // use preferred if available for carrier, else fist choise
          if (preferred && availableFormats.includes(preferred)) {
            setSelectedFormat(preferred);
          } else {
            setSelectedFormat(availableFormats[0] || null);
          }
        }
      } catch (_) {
        if (mounted) setSelectedFormat(availableFormats[0] || null);
      }
      if (mounted) setIsPrefLoading(false);
    })();
    return () => { mounted = false; };
  }, [carrierCode, isOpen, JSON.stringify(availableFormats)]);

  const updateFormat = async (format) => {
    setSelectedFormat(format);
    // store on backend
    try { await setLabelFormat(carrierCode, format); } catch (_) {}
  };

  return { selectedFormat, updateFormat, isPrefLoading };
}
